module.exports = __webpack_public_path__ + "img/portada-comision.7ebbbe34.jpg";